import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformKeysToCamelCase } from 'helpers/core';
import URLS from 'constants/urls';

// TODO(kamil): This should be Done on the BE side
export const decorateResponse = ({ averageRatings, ...restData }) => ({
  averageRatings,
  isEmpty: averageRatings && Number(averageRatings.overall.count) === 0,
  ...restData,
});

const handler = ({ httpClient }, venueId, filters) => {
  const endpoint = URLS.ratings.statistics(venueId, filters);

  return httpClient
    .get(endpoint)
    .then(({ data }) => transformKeysToCamelCase(data))
    .then(decorateResponse);
};

export default makeEntityScaffold('SAGA.API.FETCH_REVIEWS_STATISTICS', handler, {
  defaultKey: (_, venueId, filters) => `${venueId}_${JSON.stringify(filters)}`,
});
